import { LOAD_STATE } from '../../../../shared/axios';
import { createReducer, INITIAL_STATE } from '../../../../shared/redux';
import {
    buildGetStripeCustomerApiConfig,
    buildCreateStripeCustomerApiConfig,
    buildUpdateStripeCustomerApiConfig,
} from './stripe-customer.api';

export const HANDLE_SUBMIT_STRIPE_CUSTOMER = '@billing/stripe/stripe-customer/HANDLE_SUBMIT_STRIPE_CUSTOMER';

export const GET_STRIPE_CUSTOMER_REQUEST_CALLED = '@billing/stripe/stripe-customer/GET_STRIPE_CUSTOMER_REQUEST_CALLED';
export const GET_STRIPE_CUSTOMER_REQUEST_SUCCEEDED = '@billing/stripe/stripe-customer/GET_STRIPE_CUSTOMER_REQUEST_SUCCEEDED';
export const GET_STRIPE_CUSTOMER_REQUEST_FAILED = '@billing/stripe/stripe-customer/GET_STRIPE_CUSTOMER_REQUEST_FAILED';

export const CREATE_STRIPE_CUSTOMER_REQUEST_CALLED = '@billing/stripe/stripe-customer/CREATE_STRIPE_CUSTOMER_REQUEST_CALLED';
export const CREATE_STRIPE_CUSTOMER_REQUEST_SUCCEEDED = '@billing/stripe/stripe-customer/CREATE_STRIPE_CUSTOMER_REQUEST_SUCCEEDED';
export const CREATE_STRIPE_CUSTOMER_REQUEST_FAILED = '@billing/stripe/stripe-customer/CREATE_STRIPE_CUSTOMER_REQUEST_FAILED';

export const UPDATE_STRIPE_CUSTOMER_REQUEST_CALLED = '@billing/stripe/stripe-customer/UPDATE_STRIPE_CUSTOMER_REQUEST_CALLED';
export const UPDATE_STRIPE_CUSTOMER_REQUEST_SUCCEEDED = '@billing/stripe/stripe-customer/UPDATE_STRIPE_CUSTOMER_REQUEST_SUCCEEDED';
export const UPDATE_STRIPE_CUSTOMER_REQUEST_FAILED = '@billing/stripe/stripe-customer/UPDATE_STRIPE_CUSTOMER_REQUEST_FAILED';

export const getStripeCustomerData = state => state.billing
    .stripeCustomer.data;

export const getStripeCustomerLoadState = state => state.billing
    .stripeCustomer.loadState;

export const handleSubmitStripeCustomer = paymentMethodId => ({
    type: HANDLE_SUBMIT_STRIPE_CUSTOMER,
    payload: {
        paymentMethodId,
    },
});

export const getStripeCustomerRequest = () => ({
    type: GET_STRIPE_CUSTOMER_REQUEST_CALLED,
    actionTypes: {
        success: GET_STRIPE_CUSTOMER_REQUEST_SUCCEEDED,
        fail: GET_STRIPE_CUSTOMER_REQUEST_FAILED,
    },
    config: buildGetStripeCustomerApiConfig(),
});

export const createStripeCustomerRequest = data => ({
    type: CREATE_STRIPE_CUSTOMER_REQUEST_CALLED,
    actionTypes: {
        success: CREATE_STRIPE_CUSTOMER_REQUEST_SUCCEEDED,
        fail: CREATE_STRIPE_CUSTOMER_REQUEST_FAILED,
    },
    config: buildCreateStripeCustomerApiConfig(data),
});

export const updateStripeCustomerRequest = ({ stripeCustomerId, data }) => ({
    type: UPDATE_STRIPE_CUSTOMER_REQUEST_CALLED,
    actionTypes: {
        success: UPDATE_STRIPE_CUSTOMER_REQUEST_SUCCEEDED,
        fail: UPDATE_STRIPE_CUSTOMER_REQUEST_FAILED,
    },
    config: buildUpdateStripeCustomerApiConfig({ stripeCustomerId, data }),
});


const initialState = {
    loadState: LOAD_STATE.SUCCESS,
    error: null,
    data: null,
};

export const stripeCustomerReducers = createReducer({
    [INITIAL_STATE]: initialState,
    [GET_STRIPE_CUSTOMER_REQUEST_CALLED]: state => ({
        ...state,
        data: null,
        loadState: LOAD_STATE.LOADING,
    }),
    [GET_STRIPE_CUSTOMER_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.SUCCESS,
        data: action.payload.data,
    }),
    [GET_STRIPE_CUSTOMER_REQUEST_FAILED]: state => ({
        ...state,
        loadState: LOAD_STATE.FAIL,
    }),
    [UPDATE_STRIPE_CUSTOMER_REQUEST_CALLED]: state => ({
        ...state,
        loadState: LOAD_STATE.LOADING,
    }),
    [UPDATE_STRIPE_CUSTOMER_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.SUCCESS,
        data: action.payload.data,
    }),
    [UPDATE_STRIPE_CUSTOMER_REQUEST_FAILED]: state => ({
        ...state,
        loadState: LOAD_STATE.FAIL,
    }),
    [CREATE_STRIPE_CUSTOMER_REQUEST_CALLED]: state => ({
        ...state,
        loadState: LOAD_STATE.LOADING,
    }),
    [CREATE_STRIPE_CUSTOMER_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.SUCCESS,
        data: action.payload.data,
    }),
    [CREATE_STRIPE_CUSTOMER_REQUEST_FAILED]: state => ({
        ...state,
        loadState: LOAD_STATE.FAIL,
    }),
});
